import { selectionStore } from "../stores/selection.store";
import {
  BookingState,
  Hour,
  IDisplayAvailablePeriods,
  IDisplayPeriod,
  ISlot,
  Period,
  PeriodsResponse,
} from "../types";
import { Observable, Subject } from "rxjs";
import { getAvailablePeriods } from "../requests/periods.requests";
import filtersService from "../services/filters.service";
import { moduleSettings } from "../stores/module-settings.store";
import { map, catchError } from "rxjs/operators";

class IDisplayPeriodsBuilderService {
  static service: IDisplayPeriodsBuilderService | undefined;

  static get(): IDisplayPeriodsBuilderService {
    if (!this.service) {
      this.service = new IDisplayPeriodsBuilderService();
    }
    return this.service!;
  }

  public periodsApiError: boolean = false;
  public periodsLoading: boolean = false;
  public periodsState$ = new Subject<{ loading: boolean; error: boolean }>();

  public getAvailableIDisplayPeriods(
    engineMode: any
  ): Observable<IDisplayAvailablePeriods> {
    this.periodsLoading = true;
    this.periodsApiError = false;
    this.periodsState$.next({ loading: true, error: false });
    return getAvailablePeriods().pipe(
      map((resp: PeriodsResponse) => {
        this.periodsLoading = false;
        this.periodsApiError = false;
        this.periodsState$.next({ loading: false, error: false });
        return {
          displayPeriods: this.buildIDisplayPeriods(resp.periods),
          filters: filtersService.getFiltersFromPeriods(
            moduleSettings.areas,
            resp.periods,
            engineMode && engineMode["engineMode"]
          ),
          message: resp.message,
        };
      }),
      catchError((error: any) => {
        this.periodsLoading = false;
        this.periodsApiError = true;
        this.periodsState$.next({ loading: false, error: true });
        throw error;
      })
    );
  }

  public buildIDisplayPeriods(periods: Period[]): Array<IDisplayPeriod> {
    let dispPeriod: Array<IDisplayPeriod> = [];

    let nonBookableEventIds: String[] = [];
    periods.forEach((period) => {
      if (period.non_bookable_event) {
        return nonBookableEventIds.push(period.non_bookable_event.event_id);
      }
    });
    const isUniqEvent = Array.from(new Set(nonBookableEventIds)).length === 1;

    if (periods.length === nonBookableEventIds.length && isUniqEvent) {
      dispPeriod.push({
        titleKey: "",
        noHourReason: periods[0].no_hour_reason,
        nonBookableEvent: periods[0].non_bookable_event,
      });
    } else {
      dispPeriod = this.builsITimeSlots(periods);
    }
    return dispPeriod;
  }

  private builsITimeSlots(periods: Period[]) {
    const dispPeriod: Array<IDisplayPeriod> = [];
    const selectedTime = selectionStore.time;
    periods
      .filter((x) => x != null)
      .forEach((period: Period) => {
        if (!period || period.hours.length === 0) {
          dispPeriod.push({
            titleKey: period.period,
            noHourReason: period.no_hour_reason,
            nonBookableEvent: period.non_bookable_event,
          });
        } else {
          const hours: Array<ISlot> = this.buildITimeSlotsFromHours(
            period.hours,
            selectedTime
          );
          dispPeriod.push({ titleKey: period.period, hours: hours });
        }
      });
    return dispPeriod;
  }

  private buildITimeSlotsFromHours(
    hours: Hour[],
    selectedTime: string | null
  ): Array<ISlot> {
    const iTimeSlots: Array<ISlot> = [];
    hours.forEach((hour: Hour) =>
      iTimeSlots.push(
        this.buildITimeSlotDetails(
          hour,
          selectedTime ? selectedTime === hour.time : false
        )
      )
    );
    return iTimeSlots;
  }

  private buildITimeSlotDetails(hour: Hour, isSelected: boolean): ISlot {
    return {
      value: hour.time,
      icons: {
        hasOffer: hour.event || (hour.offers && hour.offers.length > 0),
        hasWaitingList: hour.booking_state === BookingState.waiting,
        hasPrepayment: hour.has_prepayment,
      },
      isSelected: isSelected,
    };
  }
}
export default IDisplayPeriodsBuilderService.get();
